import styled from 'styled-components';
import { Button } from '@material-ui/core';

export const WelcomeMessageWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing * 20}px ${({ theme }) => theme.spacing * 6}px;
  text-align: center;
  display: flex;
  flex-direction: column;
  h3 {
    font-size: 36px;
    color: ${({ theme }) => theme.colors.white};
    margin-top: 1em;
    margin-bottom: 1em;
    font-weight: bold;
  }
`;

export const FooterWrapper = styled.div`
  margin: auto 0 0;
  p {
    font-size: 12px;
    margin: 8px 0;
  }
`;

export const StyledButton = styled(Button)`
  && {
    width: 100%;
    border-radius: 6px;
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.white};
    font-weight: bold;
    padding: 0 ${({ theme }) => theme.spacing * 8}px;
    height: 44px;
    &:hover {
      color: ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
